<template>
	<div class="user-container">
		<button v-if="user.isAdded"
				class="is-added"
				v-on:click="removeOfList">
			<i class="material-icons">cancel</i>
		</button>
		<input hidden
			   :id="`user-${user.id}`"
			   name="user-selector"
			   type="radio"
			   :value="user"
			   :disabled="user.isOnlyRead"
			   v-on:change="radioOnChange(user)">
		<label class="user-selector"
			   :for="`user-${user.id}`"
			   :class="{ 'disabled' : user.isOnlyRead }">
			<span class="user-avatar">
				<img :alt="user.name" :src="user.url_image">
			</span>
			<div class="user-data">
				<v-layout row wrap>
					<span class="user-name">{{ user.name }} {{ user.lastname }}</span>
				</v-layout>
				<v-layout row wrap>
					<span v-if="user.quantity_rooms" class="user-assignments">{{ user.quantity_rooms }} mucamas</span>
					<span v-if="user.room_assigned >= 0" class="user-assignments">{{ user.room_assigned }} habitaciones</span>
				</v-layout>
			</div>
		</label>
	</div>
</template>

<script>
	function radioOnChange(value) {
		this.$emit('radio-on-change', value);
	}

	function removeOfList() {
		this.$emit('on-user-removed');
	}

	export default {
		methods: {
			radioOnChange,
			removeOfList,
		},
		name: 'user-selector',
		props: {
			user: {
				type: Object,
				required: true,
			},
		},
	};
</script>

<style lang="scss" scoped>
	.user-container {
		display: inline-flex;
		margin: 0 13px 15px 0;
		position: relative;
	}
	
	.user-selector {
		align-items: center;
		background: white;
		border-radius: 0px;
		box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, .18);
		cursor: pointer;
		justify-content: flex-start;
		min-height: 63px;
		outline: none;
		padding: 8px 14px;
		vertical-align: middle;
		white-space: nowrap;
		width: 204.4px;

		.user-avatar {
			align-items: center;
			border-radius: 50%;
			display: inline-flex;
			height: 46px !important;
			justify-content: center;
			margin-left: 0px;
			margin-right: 8px;
			overflow: hidden;
			text-align: center;
			vertical-align: middle;
			width: 46px !important;

			img {
				height: 100%;
				width: 100%;
			}
		}

		.user-data {
			display: inline-block;
			flex-wrap: wrap;
			line-height: normal;
			vertical-align: middle;
		}

		.user-name {
			color: map-get($colors, default-dark);
			font-family: map-get($fonts, medium);
			font-size: map-get($sizes, fifteen);
			max-width: 120px;
			text-transform: capitalize;
			white-space: normal;
			word-break: break-word;
		}

		.user-assignments {
			color: map-get($colors, default-button-color);
			display: block;
			font-family: map-get($fonts, regular);
			font-size: map-get($sizes, fourteen);
		}

		&.disabled {
			cursor: default;
			pointer-events: none;
		}
	}

	input:checked + .user-selector {
		background: map-get($colors, default-skyblue);

		.user-name,
		.user-assignments {
			color: white;
		}
	}

	.is-added {
		background-color: white;
		border-radius: 50%;
		height: 15px;
		margin: 0px;
		outline: none;
		position: absolute;
		right: -5px;
		top: -4px;
		width: 15px;
		z-index: 1;

		i {
			color: map-get($colors, default-dark);
			font-size: map-get($sizes, twenty);
			line-height: 15px;
			margin-left: -2px;
		}
	}
</style>




// WEBPACK FOOTER //
// UserSelector.vue?50175982